import React from "react";
import "../../Styles/Purchaseorder.css";

const FormField = ({ label, type = "text", placeholder }) => (
    <div className="form-field">
        <label>{label}</label>
        <input type={type} placeholder={placeholder} className="input" />
    </div>
);

const Inventory = () => {
    return (
        <div className="purchase-order-form">
            <div className="card">
                {/* Section 1 */}
                <h2>Transfer Between Warehouses</h2>
                <div className="form-grid">
                    <FormField placeholder="Transfer ID" />
                    <FormField type="date" />
                    <FormField placeholder="Source Warehouse" />
                    <FormField placeholder="Destination Warehouse" />
                    <FormField placeholder="Item" />
                    <FormField placeholder="Quantity" />
                    <FormField placeholder="Lot Number" />
                </div>
                <div className="form-buttons1">
                    <button className="btn submit">Transfer Stock</button>
                </div>

                {/* Section 2 */}
                <h3>Record Stock Loss / Disposal</h3>
                <div className="form-grid">
                    <FormField placeholder="Item" />
                    <FormField placeholder="Quantity" />
                    <FormField placeholder="Reason / Tag" />
                    <FormField placeholder="Warehouse" />
                </div>
                <div className="form-buttons1">
                    <button className="btn submit">Record Loss</button>
                </div>

                {/* Section 3 */}
                <h3>Add FG Batch Document</h3>
                <div className="form-grid">
                    <FormField placeholder="Batch Number" />
                    <FormField

                        placeholder="Document Type"
                    />
                    <div className="form-field full-width">

                        <input type="file" className="input" />
                    </div>
                </div>
                <div className="form-buttons1">
                    <button className="btn submit">Upload Document</button>
                </div>

                {/* Section 4 */}
                <h3>View Stock by Lot</h3>
                <div className="form-grid">
                    <FormField placeholder="Lot Number" />
                    <FormField type="date" />
                    <FormField type="date" />
                </div>

                <div className="form-buttons1">
                    <button className="btn submit">Search Stock</button>
                </div>
            </div>
        </div>
    );
};

export default Inventory;
